import at from './at';
import books from './books';
import humanResources from './humanResources';
import operations from './operations';
import pei from './pei';
import scholarship from './scholarship';
import security from './security';
import helpdesk from './helpdesk';
import evaluations from './evaluations';
//ShareV2 = (No Toques Delicado)
import shared from './shared';
import student from './student';
import welcome from './welcome-portal';
import materials from './materials';
export default [
  {
    path: '/',
    name: 'layout',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/template/Layout.vue'),
    children: [
      {
        path: '', //TODO: Path = / (Not dashboard)
        name: 'dashboard',
        component: () => import('@/views/Dashboard'),
      },
      ...student,
      ...pei,
      ...at,
      ...security,
      ...operations,
      ...scholarship,
      ...books,
      ...humanResources,
      ...helpdesk,
      ...shared,
      ...materials,
      ...evaluations,
      {
        path: 'signature-hub/:typeId/:relatedId',
        name: 'SignatureHub',
        component: () => import('@/views/signature-hub/Main.vue'),
      },
    ],
  },
  {
    path: '/pei/definition/:peiId?',
    name: 'peiDefinition',
    component: () => import('@/components/pei/DefinitionWizard'),
  },

  ...welcome,
  {
    path: '**',
    redirect: { name: 'dashboard' },
  },
  {
    path: '',
    redirect: { name: 'dashboard' },
  },
];
